






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ChangelogHyperlink, ChangelogHyperlinks } from '@/common/Constants';

@Component({})
export default class ChangelogLink extends Vue {
	@Prop({ required: true })
	public values!: any | null;

	public items: {
		field: string;
		type: 'link' | 'text';
		value?: string | null;
		link?: { name: string; params: { [key: string]: string } } | null;
	}[] = [];

	@Watch('value')
	public created(): void {
		this.items = [];
		if (!this.values) return;
		let parsed = this.values;
		if (typeof parsed === 'string') {
			try {
				parsed = JSON.parse(parsed.toString());
			} catch (ignored) {}
		}
		Object.keys(parsed).forEach(key => {
			const hyperlink: ChangelogHyperlink | undefined = ChangelogHyperlinks.find(
				link => link.field === key,
			);
			let value = parsed[key];
			try {
				const jsonParsed = JSON.parse(value);
				value =
					typeof jsonParsed === 'object'
						? Object.keys(jsonParsed).map(
								k => `${this.$options.filters?.keyToText(k)}: ${jsonParsed[k]}`,
						  )
						: this.isArray(jsonParsed)
						? jsonParsed.map(v => this.$options.filters?.titleCase(v) ?? v).join(', ')
						: value;
			} catch (_) {}
			if (hyperlink)
				this.items.push({
					field: key,
					type: 'link',
					value: value,
					link: {
						name: hyperlink.route,
						params: {
							[hyperlink.paramName]: parsed[key],
						},
					},
				});
			else this.items.push({ field: key, type: 'text', value: value });
		});
	}

	public isArray(val: any) {
		return Array.isArray(val);
	}
}
